/* eslint-disable @typescript-eslint/naming-convention */
import { Note } from './note'
import { DriverStatus } from './user'

export interface SlimUserPayload {
  id: string
  email: string
  first_name: string
  last_name: string
}

export interface UserStatusHistory {
  updated_by: SlimUserPayload
  date_start: string
  date_end: string
  status: DriverStatus
  status_detail?: string
  status_reason?: string
  team_user_id: string
}

export interface UserTimelinePayload {
  total_length: number
  suspension_count: number
  results: Array<Note | UserStatusHistory>
}

export const SuspendedDriverReasons: Record<string, any> = {
  INVALID_INSURANCE: { id: 'INVALID_INSURANCE', name: 'Lapsed insurance' },
  BAD_FAITH_CANCELATION: { id: 'BAD_FAITH_CANCELATION', name: 'Bad faith cancelation' },
  INVALID_CDL_CARD: { id: 'INVALID_CDL_CARD', name: 'Invalid CDL card' },
  INVALID_MED_CARD: { id: 'INVALID_MED_CARD', name: 'Invalid med card' },
  TRUCK_BREAKDOWN: { id: 'TRUCK_BREAKDOWN', name: 'Truck breakdown' },
  DRIVER_INACTIVE: { id: 'DRIVER_INACTIVE', name: 'Driver inactive' },
  POOR_SAFETY_PERFORMANCE: { id: 'POOR_SAFETY_PERFORMANCE', name: 'Poor safety performance' },
  ACCIDENT: { id: 'ACCIDENT', name: 'Accident' },
  OTHER_SUSPENSION_REASON: { id: 'OTHER_SUSPENSION_REASON', name: 'Other' },
}
